import { useCallback, useEffect } from 'react'
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js'
import { DeviceLabels, MeetingManagerJoinOptions, useMeetingManager } from 'amazon-chime-sdk-component-library-react'
import { useGetExpertiseMeetingSessionQuery } from '@/core/services/expertise-meeting'

export function useMeetingSession(expertiseMeetingId: string) {
  const { meetingInfo, localAttendeeInfo } = useGetExpertiseMeetingSessionQuery(expertiseMeetingId, {
    selectFromResult: ({ data }) => ({ meetingInfo: data?.meeting, localAttendeeInfo: data?.attendee }),
  })

  const meetingManager = useMeetingManager()

  const startMeeting = useCallback(
    async (meetingInfo: any, attendeeInfo: any) => {
      const meetingSessionConfiguration = new MeetingSessionConfiguration(meetingInfo, attendeeInfo)
      const options: MeetingManagerJoinOptions = {
        deviceLabels: DeviceLabels.AudioAndVideo,
        enableWebAudio: true,
      }
      await meetingManager.join(meetingSessionConfiguration, options)
      await meetingManager.start()
    },
    [meetingManager]
  )

  useEffect(() => {
    if (meetingInfo && localAttendeeInfo) {
      startMeeting(meetingInfo, localAttendeeInfo)
    }
  }, [startMeeting, localAttendeeInfo, meetingInfo])

  useEffect(() => {
    return () => {
      meetingManager.leave()
    }
  }, [meetingManager])

  return { meetingInfo, localAttendeeInfo }
}
